import { Component, OnInit } from '@angular/core';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { ConfirmActionComponent } from 'src/app/components/dialog/confirm/confirm-action/confirm-action.component';
import { OrgDepartmentsActionsComponent } from 'src/app/components/dialog/organization/org-departments-actions/org-departments-actions.component';
import { PaginationInput, PaginationPageEvent, ListParams, Res } from 'src/app/models';
import { OrgDepartmentsList } from 'src/app/models/org-departments.model';
import { LanguageService, NotificationService, ApiOrgDepartmentsService, DialogModalService } from 'src/app/services';

@Component({
  selector: 'app-departments-list',
  templateUrl: './departments-list.component.html',
  styleUrls: ['./departments-list.component.css']
})
export class DepartmentsListComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  departments: OrgDepartmentsList[] = [];
  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent;
  listParams: ListParams;

  constructor(
    public ngProgress: NgProgress,
    private languageService: LanguageService,
    private apiOrgDepartments: ApiOrgDepartmentsService,
    private notification: NotificationService,
    private dialogModal: DialogModalService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');

    this.getList();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   */
  getList(): void {

    this.progressRef.start();
    this.loading = true;
    this.departments = [];

    this.setListParams();

    this.apiOrgDepartments.getList(this.listParams).subscribe((response: Res) => {
      console.log('[RESPONSE] getList organizations: ', response);


      if (response != null) {

        if (response.result != null) {

          this.departments = response.result.list;

          this.paginationInput = {
            count: response.result.count,
            numberOfPages: response.result.numberOfPages,
            currentPage: this.listParams.pageNumber,
            size: this.listParams.countOnPage
          }
        }
      }

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });
  }

  /**
  * 
  * @param ids 
  */
  onConfirm(ids: string[]) {

    let message = 'Вы действительно хотите удалить?';

    this.dialogModal.open(message, ConfirmActionComponent, '', 'confirmAction-window').then(
      (result) => {

        if (result) {

          this.onDelete(ids);
        }
      },
      () => { console.log('Rejected!'); }
    );

  }

  /**
  * 
  * @param ids 
  */
  onDelete(ids: string[]): void {

    this.progressRef.start();

    this.subscriptions.add(
      this.apiOrgDepartments.delete({ id: ids }).subscribe(response => {

        if (response != null) {

          this.getList();

          this.notification.show('success', 'Данные успешно удалены!');
        }

        this.progressRef.complete();
      })
    );
  }

  /**
   * 
   */
  // deleteSelected(): void {

  //   let ids = [...new Set(this.organizations.filter(val => val.checked).map(({ id }) => id))];
  //   this.onDelete(ids);
  // }


  /**
   * 
   */
  setListParams(): void {

    this.listParams = {
      filter: {
        name: ''
      },
      object: 'organization',
      pageNumber: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }


  /**
   * 
   * @param event 
   */
  pageEvent(event: PaginationPageEvent): void {

    this.paginationOutput = event;
    this.getList();
  }

  /**
   * 
   */
  onCreate() {

    this.dialogModal.open('', OrgDepartmentsActionsComponent).then(
      (result) => {
        console.log("RESULT: ", result);

        if (result) {

          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
   * 
   * @param i 
   */
  onEdit(i: number) {

    let data = {
      department_id: this.departments[i].id
    }

    this.dialogModal.open(data, OrgDepartmentsActionsComponent).then(
      (result) => {

        if (result) {

          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }



}
